


















































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ExporoLoading from '@/components/app/ExporoLoading.vue';
import MessageModal from '@/components/app/MessageModal.vue';
import MaintenanceModal from '@/components/app/MaintenanceModal.vue';
import AppLoadingBar from '@/components/app/AppLoadingBar.vue';
import AppSidebar from '@/components/app/AppSidebar.vue';
import AppHeader from '@/components/app/AppHeader.vue';
import AppNavBar from '@/components/app/AppNavBar.vue';

import { centsToEuro } from '@/filters/currency';
import { Trade } from '@/store/sellOffer/types';
import { UserWallet } from './store/wallet/types';
import { Asset } from './store/asset/types';

Component.registerHooks([ 'validations' ]);

@Component({
  components: {
    MessageModal,
    MaintenanceModal,
    AppHeader,
    AppLoadingBar,
    ExporoLoading,
    AppSidebar,
    AppNavBar,
  },
  filters: {
    centsToEuro,
  },
})

export default class App extends Vue {
  // Set this to true to enable maintenance mode and block the UI
  get maintenanceMode() {
    return true;
  }
  @Getter('appState/isLoading') isLoading?: Boolean;
  @Getter('appState/menuOpen') menuOpen?: boolean;
  @Action('appState/toggleMenu') toggleMenu: Function;

  @Getter('profile/fullName') fullName?: string;
  @Getter('profile/exporoId') exporoId?: string;
  @Action('profile/signOut') signOut: Function;

  @Getter('asset/asset') asset?: Asset;
  @Getter('asset/errorLoadingAsset') errorLoadingAsset?: string;
  @Getter('sellOffer/createdSellOffer') createdSellOffer?: string;
  @Getter('sellOffer/verifiedTrades') verifiedTrades?: Trade[];
  @Getter('sellOffer/errorLoadingSellOffer') errorLoadingSellOffer?: string;
  @Getter('stepper/steps') steps?: string[];
  @Getter('stepper/activeStep') activeStep?: number;
  @Action('stepper/setActive') setActive;
  @Getter('wallet/userWallet') userWallet?: UserWallet;
  @Getter('wallet/wallet') wallet?: any;

  get isLoadingData() {
    return this.isLoading && !this.userWallet && !this.wallet;
  }

  get showSteps() {
    return this.steps.length > 0 && this.$route.name === 'tradeSellOffer' ||
      this.$route.name === 'sellOffer';
  }

  get showMenu() {
    const showMenuRoutes = ['myTrades','mySellOffers','mySecurities'];

    return showMenuRoutes.includes(this.$route.name);
  }
  
  get balance() {
    return this.$options.filters.centsToEuro(this.wallet?.amount || 0);
  }

  get assetIsBaader() {
    return this.asset?.provider === 'baaderbank';
  }
}
